import '../styles/AdminIdentityPlate.css';
import React from 'react';
import { useProjectCollection } from '../lib/projectData';

const ACCOUNTS_COLLECTION = 'accounts';

const FALLBACK_ADMIN = {
  email: 'hellomcdonald8@gmail.com',
  role: 'administrator',
  displayName: 'Fast Forward Administrator',
  createdAt: '2026-01-04',
};

function AdminIdentityPlate() {
  const { data, loading, error } = useProjectCollection(ACCOUNTS_COLLECTION);

  const records = Array.isArray(data) ? data : [];
  const canonicalAdmin = records.find(
    (record) => record && record.email === FALLBACK_ADMIN.email
  );
  const admin = canonicalAdmin || FALLBACK_ADMIN;

  const statusLabel = loading ? 'Reading' : error ? 'Unavailable' : 'Only';

  return (
    <section className="aip-root" aria-label="Administrator identity">
      <div className="aip-plate">
        <div className="aip-row">
          <div className="aip-label-cell">
            <span className="aip-label">Administrator</span>
            <span className="aip-index" aria-hidden="true">01</span>
          </div>

          <div className="aip-value-cell">
            <span className="aip-identity">
              <span className="aip-pip" aria-hidden="true" />
              <span className="aip-email">{admin.email}</span>
            </span>

            <span className="aip-verified">
              <span className="aip-verified-dot" aria-hidden="true" />
              <span className="aip-verified-word">{statusLabel}</span>
            </span>
          </div>
        </div>

        <p className="aip-context">
          Sole service account for Fast Forward Deliver Services &mdash; read-only
          instrument record, bound to the consignment workspace and the tracking surface.
        </p>
      </div>
    </section>
  );
}

export default AdminIdentityPlate;